import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Table,
  Container,
} from "react-bootstrap";
import Nav from "./Navbar";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleRight,
  FaArrowRight,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import Footer from "./Footer";
import tool7 from "../Images/tool7.png";
import tool6 from "../Images/tool6.png";
import tool8 from "../Images/tool8.png";
import SideTab from "./Toolstab";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import swal from "sweetalert";
import TestimonialPage from "./Testonomialraghar";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const relatedTools = [
  {
    name: "SERP Simulator",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "See how your site appears in Google results. A well-organized snippet can boost exposure, encourage more clicks, and enhance SEO performance in general.",
    href: "/serp-simulator",
  },
  {
    name: "DA PA Checker",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "Evaluate your website's Domain Authority and Page Authority instantly. Great for understanding site credibility and planning SEO outreach.",
    href: "/da-pa-checker",
  },
  ,
  {
    name: "Top Pages",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Identify your highest-performing pages by traffic and engagement. Use this insight to replicate success and refine your SEO content strategy effectively.",
    href: "/top-pages",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Left Arrow */}
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="mt-4">
      <p>
        If you're putting in all the effort to grow your website but still not
        seeing the results you want, chances are you're missing the keywords
        your competitors are already ranking for. That’s the hidden edge most
        growing websites ignore. Imagine if you could peek into what’s working
        for your rivals and use that insight to build something even better —
        that’s where Seobix, a reliable <b>competitor analysis tool</b>, steps
        in. With its smart <b>website analyzer tool</b> and beginner-friendly
        dashboard, Seobix helps you build a strong{" "}
        <b>keyword research strategy for beginners</b>. If you're searching for
        the <b>best tool to find competitors' keyword</b>s, Seobix gives you the
        edge to uncover opportunities, fill in content gaps, and boost your SEO
        performance.
      </p>
      {/* <div className="d-flex justify-content-center">
        <img
          className="m-3"
          src={tool6}
          alt="seobix"
          style={{ width: "50vw" }}
        />
      </div> */}
      <h2>What Makes Seobix the Best Tool to Find Competitors' Keywords?</h2>
      <div style={{ position: "relative" }}>
        <p>
          If you're struggling to grow your website's traffic, one big reason
          could be that you're missing out on the right keywords. The keywords
          your competitors are ranking for might just be the ones you need. With
          Seobix, analyzing your competitors becomes effortless. Whether you’re
          just starting with SEO or already know your way around it, Seobix
          helps you find the hidden opportunities your rivals are already using.
        </p>
        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>
      {showMore && (
        <>
          <div className="d-flex justify-content-center">
            <img
              className="m-5"
              src={tool8}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <h3>Why Competitor Keyword Analysis Matters</h3>
          <p>
            A strong <b>keyword research strategy for beginners</b> should
            always include competitor analysis. Instead of guessing what might
            work, you can simply see what already works for others in your
            niche. Seobix helps by giving you a detailed look at your
            competitors’ top-performing keywords. You get to understand which
            keywords drive the most traffic to their websites — and which ones
            you're missing out on.
          </p>
          <p>
            That’s how Seobix turns keyword research into a smart strategy
            rather than a guessing game.
          </p>
          <h4
            className="text-center mt-4 mb-3"
            style={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: "#0A3981",
            }}
          >
            🔧 Related Tools
          </h4>
          <ToolSlider />
          <h3>The Real SEO Ranking Problems People Face Today</h3>
          <p>
            One of the biggest issues is that most people don’t really know
            what’s working for their competitors. They guess. They write content
            around keywords they assume are valuable, but they miss what their
            audience is actually clicking on. That’s why so many websites remain
            invisible, even after publishing great content.
          </p>
          <p>
            Another major hurdle is technical SEO. Many sites have issues with
            structure, page speed, or broken links, and they never even realize
            it. That’s why having a reliable website analyzer tool is essential.
            Without it, you're flying blind.
          </p>
          <p>
            But even with the basics covered, beginners often get overwhelmed.
            They don’t know where to begin. That’s where a smart, easy-to-use{" "}
            <b>keywords research strategy for beginners</b>
            can make all the difference. If you can identify what your
            competitors are doing right — and where they’re getting their
            traffic — you’ve already won half the battle.
          </p>
          <div className=" mb-3 d-flex justify-content-center">
            <img
              style={{ width: "50vw" }}
              className="mb-3"
              src={tool7}
              alt="seobix"
            />
          </div>
          <h2>Search Intent: What Are People Really Looking For?</h2>{" "}
          <p className="mb-5">
            A strong <b>keyword research strategy for beginners</b> should
            always include competitor analysis. Instead of guessing what might
            work, you can simply see what already works for others in your
            niche. Seobix helps by giving you a detailed look at your
            competitors’ top-performing keywords. You get to understand which
            keywords drive the most traffic to their websites — and which ones
            you're missing out on.
          </p>
          <p>
            That’s how Seobix turns keyword research into a smart strategy
            rather than a guessing game.
          </p>
          <h3>Designed for Beginners and SEO Pros Alike</h3>
          <p>
            When you’re trying to grow a website or online business, one thing
            becomes clear pretty quickly — it’s not just about writing good
            content anymore. It’s about writing the right content. The kind that
            your audience is already searching for. That’s where many people hit
            a wall. You might be putting in the work, publishing blogs, updating
            pages, and still… the traffic just isn’t coming. That’s often
            because your competitors are ranking for the keywords you’re not
            even targeting yet.
          </p>
          <h2>How Seobix Helps You Beat the Competition</h2>
          <p>
            Most SEO beginners ask: Where do I start? Seobix gives you a solid
            starting point with its built-in <b>website analyzer tool</b>. Just
            enter a competitor’s domain, and Seobix shows you the keywords they
            rank for, their traffic sources, keyword difficulty, and ranking
            position.
          </p>
          <p>
            Now you don’t just find keywords — you find the right keywords that
            work.
          </p>
          <p className="mb-4">
            Seobix also helps you bridge the keyword gap. It compares your site
            with your competitor’s and highlights the terms they’re ranking for
            — that you’re not. This gives you a clear direction on what content
            to create next and where to focus your efforts.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Keywordgap = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Keyword Gap – Discover Competitor Keywords with SeoBix",
    url: "https://seobix.com/keyword-gap",
    description:
      "Keyword Gap helps you discover competitor keywords and close ranking gaps. Boost visibility, target profitable keywords and grow your organic traffic.",
    applicationCategory: "SEO Tool",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      category: "Free SEO Tool",
    },
    publisher: {
      "@type": "Organization",
      name: "SeoBix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
        width: 600,
        height: 60,
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Keyword Gap",
          item: "https://seobix.com/keyword-gap",
        },
      ],
    },
    inLanguage: "en",
    keywords: [
      "Competitor keyword analysis",
      "Keyword gap tool 2025",
      "SEO keyword gap analysis",
      "Find missing keywords",
      "Competitor SEO keywords",
      "SEO opportunity analysis",
      "Keyword gap checker",
      "Keyword gap software",
    ],
  };

  return (
    <div>
      <Helmet>
        <title>Keyword Gap – Discover Competitor Keywords with SeoBix</title>
        <meta
          name="description"
          content="Keyword Gap helps you discover competitor keywords and close ranking gaps. Boost visibility, target profitable keywords and grow your organic traffic."
        />
        <link rel="canonical" href="https://seobix.com/keyword-gap" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://seobix.com/keyword-gap" />
        <meta
          property="og:title"
          content="Keyword Gap – Discover Competitor Keywords with SeoBix"
        />
        <meta
          property="og:description"
          content="Keyword Gap helps you discover competitor keywords and close ranking gaps. Boost visibility, target profitable keywords and grow your organic traffic."
        />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://seobix.com/keyword-gap" />
        <meta
          name="twitter:title"
          content="Keyword Gap – Discover Competitor Keywords with SeoBix"
        />
        <meta
          name="twitter:description"
          content="Keyword Gap helps you discover competitor keywords and close ranking gaps. Boost visibility, target profitable keywords and grow your organic traffic."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <Nav />
      <Container fluid className="p-0 mt-4">
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <Col md={10} className="mb-5">
            <h1 className="m-2 text-center" style={{ color: "#441752" }}>
              Keyword Gap
            </h1>
            <h6 className="mb-3 text-center" style={{ color: "#441752" }}>
              Identify missing keywords, analyze competitor strategies, and
              bridge the gap to improve your search rankings and online
              visibility.
            </h6>
            <Keywordgaptool />
          </Col>
        </Row>

        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <Content />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const Keywordgaptool = () => {
  const [loading, setLoading] = useState(false);
  const [selfDomain, setSelfDomain] = useState("");
  const [competitorDomain, setCompetitorDomain] = useState("");
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [apiData, setApiData] = useState([]);
  const handleRowExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const handleSubmit = async () => {
    const uuid = generateUUID();
    const session = generateUUID();
    const urls = [selfDomain, competitorDomain].filter(Boolean);
    setLoading(true);
    const scope = selectedDomainType.value === "root" ? "domain" : "subdomain";
    const requestData = {
      uuid,
      urls,
      scope,
      session,
    };
    console.log("Request Data:", requestData);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchBulkSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        setApiData(data.data);
        setLoading(false);
      } else {
        console.error("Error fetching data:", data.msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="mt-3">
      <div>
        {loading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <div className="">
          <Form className="mb-2">
            <Row className="align-items-center gx-2">
              <Col md={4}>
                <Form.Group className="mb-0">
                  <Form.Control
                    type="text"
                    placeholder="Enter your domain"
                    value={selfDomain}
                    onChange={(e) => setSelfDomain(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-0">
                  <Form.Control
                    type="text"
                    placeholder="Enter competitor domain"
                    value={competitorDomain}
                    onChange={(e) => setCompetitorDomain(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Row className="g-2 align-items-center">
                  <Col xs={9}>
                    <Form.Group className="mb-0">
                      <Form.Select
                        value={selectedDomainType}
                        onChange={(e) => setSelectedDomainType(e.target.value)}
                        aria-label="Select Domain Type"
                        style={{
                          borderRadius: "6px",
                          padding: "0.5rem",
                          fontWeight: "500",
                          color: "#333",
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value="">Select Domain Type</option>
                        <option value="root">Root Domain</option>
                        <option value="sub">Sub Domain</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xs={3}>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={handleSubmit}
                      style={{ whiteSpace: "nowrap", width: "100%" }}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <div className=" mt-4">
        {apiData.length > 0 && (
          <Table responsive>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
            </colgroup>

            <thead>
              <tr>
                <th className="text-center">Domain</th>
                <th className="px-3">Domain Authority</th>
                <th className="px-3">Page Authority</th>
                <th className="px-3">Spam Score</th>
                <th className="px-3">Check Keyword</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((item, index) => (
                <React.Fragment key={item.id}>
                  <tr>
                    <td className="text-center">{item.url}</td>

                    <td
                      className="p-2"
                      style={{ width: "100px", textAlign: "center" }}
                    >
                      <CustomDoughnut
                        value={item.da}
                        stroke="#799EFF"
                        label={`${item.da}`}
                      />
                    </td>

                    <td
                      className="p-2"
                      style={{ width: "100px", textAlign: "center" }}
                    >
                      <CustomDoughnut
                        value={item.pa}
                        stroke="#FFA500"
                        label={`${item.pa}`}
                      />
                    </td>

                    <td
                      className="p-2"
                      style={{ width: "100px", textAlign: "center" }}
                    >
                      <CustomDoughnut value={item.spam_score} size={80} />
                    </td>

                    <td className="text-center">
                      {expandedRow === index ? (
                        <FaArrowAltCircleDown
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRowExpand(index)}
                        />
                      ) : (
                        <FaArrowAltCircleRight
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRowExpand(index)}
                        />
                      )}
                    </td>
                  </tr>
                  {expandedRow === index && (
                    <tr>
                      <td colSpan={5}>
                        <RankingKeyword selectedUrl={item.url} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};
const RankingKeyword = ({ selectedUrl }) => {
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const [loading, setLoading] = useState(false);
  const [rankingKeywords, setRankingKeywords] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [queary, setqueary] = useState([]);
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  useEffect(() => {
    if (selectedUrl) {
      DomainRankingKeywords(selectedUrl);
    }
  }, [selectedUrl]);

  const DomainRankingKeywords = async (url) => {
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/DomainRankingKeywords`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: url,
            scope: "domain",
            locale: "en-US",
          }),
        }
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const rankingData = data.data.map((item) => ({
          keyword: item.keyword,
          url: item.url,
          ranking_page: item.ranking_page,
          rank_position: item.rank_position,
          difficulty: item.difficulty,
          volume: item.volume,
        }));

        setRankingKeywords(rankingData);
        setqueary({ query: data.data[0].url });
        processChartData(rankingData);
      } else if (data.error) {
        swal({
          title: "Error",
          text: data.error.message,
          icon: "error",
          button: "OK",
        });
      } else {
        swal({
          title: "No Data",
          text: "Site metrics not found in response",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.log("error", error);
      swal({
        title: "Request Failed",
        text: "An error occurred while fetching data. Please try again later.",
        icon: "error",
        button: "OK",
      });
    } finally {
    }
  };

  const processChartData = (keywords) => {
    const ranges = {
      "1-3": 0,
      "4-10": 0,
      "11-20": 0,
      "21-30": 0,
      "31-40": 0,
      "41-50": 0,
    };
    keywords.forEach((keyword) => {
      const position = keyword.rank_position;
      if (position >= 1 && position <= 3) ranges["1-3"]++;
      else if (position >= 4 && position <= 10) ranges["4-10"]++;
      else if (position >= 11 && position <= 20) ranges["11-20"]++;
      else if (position >= 21 && position <= 30) ranges["21-30"]++;
      else if (position >= 31 && position <= 40) ranges["31-40"]++;
      else if (position >= 41 && position <= 50) ranges["41-50"]++;
    });

    setChartData([
      { range: "#1-3", count: ranges["1-3"] },
      { range: "#4-10", count: ranges["4-10"] },
      { range: "#11-20", count: ranges["11-20"] },
      { range: "#21-30", count: ranges["21-30"] },
      { range: "#31-40", count: ranges["31-40"] },
      { range: "#41-50", count: ranges["41-50"] },
    ]);
  };
  const countKeywordsInRankRange = (keywords, start, end) => {
    return keywords.filter(
      (keyword) =>
        keyword.rank_position >= start && keyword.rank_position <= end
    ).length;
  };
  const range1to3 = countKeywordsInRankRange(rankingKeywords, 1, 3);
  const range4to10 = countKeywordsInRankRange(rankingKeywords, 4, 10);

  return (
    <div>
      {rankingKeywords.length > 0 && queary?.query && chartData.length > 0 ? (
        <div
          className="mb-2 p-4"
          style={{ background: "rgba(234,229,244)", borderRadius: ".4rem" }}
        >
          <h5 className="text-center" style={{ color: "#441752" }}>
            Result of Ranking Keywords
          </h5>
          <Row className="p-0">
            <Card className="p-2 m-2 col">
              <div className="row p-0 m-0">
                <div className="col justify-content-center text-center">
                  <h6>Site</h6>
                  <hr className="m-1 p-0" />
                  <h5>{queary?.query}</h5>
                </div>
                <div className="col justify-content-center text-center">
                  <h6>Ranking Keyword</h6>
                  <hr className="m-1 p-0" />
                  <h4>{rankingKeywords?.length}</h4>
                </div>
              </div>
            </Card>

            <Card className="p-2 m-2 col">
              <div>
                <h6>Top Position Keywords</h6>
                <hr className="m-1 p-0" />
                <Row className="m-0 p-0">
                  <Col>
                    <p className="mb-0"># 1-3</p>
                  </Col>
                  <Col>
                    <p className="mb-0">{range1to3} Keywords</p>
                  </Col>
                </Row>
                <Row className="m-0 p-0">
                  <Col>
                    <p className="mb-0"># 4-10</p>
                  </Col>
                  <Col>
                    <p className="mb-0">{range4to10} Keywords</p>
                  </Col>
                </Row>
              </div>
            </Card>
          </Row>

          <div className="table-container">
            <table
              className="table table-bordered w-100"
              style={{
                backgroundColor: "white",
                borderBottom: "2px solid #441752",
                color: "#441752",
              }}
            >
              <thead>
                <tr>
                  <th>Keyword</th>
                  <th>
                    Domain<h6>{queary?.query}</h6>
                  </th>
                  <th>Difficulty</th>
                  <th>Monthly Volume</th>
                </tr>
              </thead>
              <tbody>
                {rankingKeywords?.slice(0, 6).map((keywordData, index) => (
                  <tr key={index}>
                    <td>{keywordData?.keyword}</td>
                    <td>
                      #{keywordData?.rank_position}
                      <br />
                      <p className="mb-0">{keywordData?.ranking_page}</p>
                    </td>
                    <td>{keywordData?.difficulty}</td>
                    <td>{keywordData?.volume}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </div>
  );
};
const CustomDoughnut = ({ value, size = 64 }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - value) / 100) * circumference;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "relative",
      }}
    >
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#799EFF"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#0A3981",
        }}
      >
        {value}%
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Backlink Checker",
    description:
      "Easy Find out which links are missing or harmful on your site and which are not.",
    linkText: "Backlink Checker",
    linkUrl: "/backlink-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Top Pages",
    description:
      "Compare and analyze the performance of your most linked pages and that of your competitors. Learn about high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/top-pages",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Determine broken or lost backlinks and turn them into new opportunities to establish stronger relations.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Assess the authority rating and any future search engine of a web site with more than 15 reliable ranking factors and domain measures.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const { siteurl, siteid } = useContext(GlobalContext);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const domainTypeOptions = [
    { value: "domain", label: "Domain" },
    { value: "subdomain", label: "Subdomain" },
  ];

  const regionOptions = [
    { value: "en-US", label: "United States (en-US)" },
    { value: "en-GB", label: "United Kingdom (en-GB)" },
    { value: "en-CA", label: "Canada (English) (en-CA)" },
    { value: "en-AU", label: "Australia (en-AU)" },
  ];

  const [formData, setFormData] = useState({
    domainInput: siteurl,
    domainType: domainTypeOptions[0],
    region: regionOptions[0],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [rankingKeywords, setRankingKeywords] = useState([]);
  const [queary, setqueary] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const DomainRankingKeywords = async (type) => {
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/DomainRankingKeywords`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formData.domainInput,
            scope: formData.domainType?.value,
            locale: formData.region?.value,
            type: type,
          }),
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data) {
        const rankingData = data.data.map((item) => ({
          keyword: item.keyword,
          url: item.url,
          ranking_page: item.ranking_page,
          rank_position: item.rank_position,
          difficulty: item.difficulty,
          volume: item.volume,
        }));

        setRankingKeywords(rankingData);
        setqueary({ query: data.data[0].url });
        processChartData(rankingData);
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    } catch (error) {
      console.log("error", error);
      setShowResults(false);
    }
  };

  const processChartData = (keywords) => {
    const ranges = {
      "1-3": 0,
      "4-10": 0,
      "11-20": 0,
      "21-30": 0,
      "31-40": 0,
      "41-50": 0,
    };
    keywords.forEach((keyword) => {
      const position = keyword.rank_position;
      if (position >= 1 && position <= 3) ranges["1-3"]++;
      else if (position >= 4 && position <= 10) ranges["4-10"]++;
      else if (position >= 11 && position <= 20) ranges["11-20"]++;
      else if (position >= 21 && position <= 30) ranges["21-30"]++;
      else if (position >= 31 && position <= 40) ranges["31-40"]++;
      else if (position >= 41 && position <= 50) ranges["41-50"]++;
    });

    setChartData([
      { range: "#1-3", count: ranges["1-3"] },
      { range: "#4-10", count: ranges["4-10"] },
      { range: "#11-20", count: ranges["11-20"] },
      { range: "#21-30", count: ranges["21-30"] },
      { range: "#31-40", count: ranges["31-40"] },
      { range: "#41-50", count: ranges["41-50"] },
    ]);
  };

  const countKeywordsInRankRange = (keywords, start, end) => {
    return keywords.filter(
      (keyword) =>
        keyword.rank_position >= start && keyword.rank_position <= end
    ).length;
  };

  const range1to3 = countKeywordsInRankRange(rankingKeywords, 1, 3);
  const range4to10 = countKeywordsInRankRange(rankingKeywords, 4, 10);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/bix-keyword-analyzer");
  };
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setHasLoaded(true);
    }, 500);
  }, []);

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background: "linear-gradient(to right, #EDE7F6, #E3F2FD)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Your Domain's Ranking Keywords Instantly</b>
            </h3>
            <p className="text-center">
              See which keywords your website currently ranks for in search
              engines. Analyze performance, uncover SEO opportunities, and boost
              your visibility.
            </p>

            <Row className=" align-items-center rounded m-3">
              <Col md={6}>
                <Form.Control
                  type="text"
                  placeholder="Enter a domain, subdomain, or exact page"
                  value={formData.domainInput}
                  onChange={(e) => handleChange("domainInput", e.target.value)}
                />
              </Col>

              <Col md={4} className="d-flex align-items-center p-0">
                <Form.Select
                  className="mx-2"
                  value={formData.domainType.value}
                  onChange={(e) =>
                    handleChange(
                      "domainType",
                      domainTypeOptions.find(
                        (opt) => opt.value === e.target.value
                      )
                    )
                  }
                >
                  {domainTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>

                <Form.Select
                  value={formData.region.value}
                  onChange={(e) =>
                    handleChange(
                      "region",
                      regionOptions.find((opt) => opt.value === e.target.value)
                    )
                  }
                >
                  {regionOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={2} className="d-flex justify-content-center">
                <Button
                  size="sm"
                  style={{ background: "#441752", color: "#fff" }}
                  onClick={() => DomainRankingKeywords("1")}
                >
                  Analyze
                </Button>
              </Col>
            </Row>

            {showResults && (
              <>
                {" "}
                <Row className="p-0 m-2">
                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#E3F2FD",
                      border: "1px solid #90CAF9",
                    }}
                  >
                    <div className="row p-0 m-0">
                      <div className="col justify-content-center text-center">
                        <h6>Site</h6>
                        <hr className="m-1 p-0" />
                        <h5>{queary?.query}</h5>
                      </div>
                      <div className="col justify-content-center text-center">
                        <h6>Ranking Keyword</h6>
                        <hr className="m-1 p-0" />
                        <h4>{rankingKeywords?.length}</h4>
                      </div>
                    </div>
                  </Card>

                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#FFF3E0",
                      border: "1px solid #FFB74D",
                    }}
                  >
                    <div>
                      <h6>Top Position Keywords</h6>
                      <hr className="m-1 p-0" />
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 1-3</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range1to3} Keywords</p>
                        </Col>
                      </Row>
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 4-10</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range4to10} Keywords</p>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Row>
                <div className="table-container m-3">
                  <table
                    className="table table-bordered w-100 mt-3"
                    style={{
                      backgroundColor: "#F3E5F5",
                      borderBottom: "2px solid #6A1B9A",
                      color: "#4A148C",
                    }}
                  >
                    <thead style={{ backgroundColor: "#CE93D8" }}>
                      <tr>
                        <th>Keyword</th>
                        <th>
                          Domain<h6>{queary?.query}</h6>
                        </th>
                        <th>Difficulty</th>
                        <th>Monthly Volume</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rankingKeywords
                        ?.slice(0, 5)
                        ?.map((keywordData, index) => {
                          const isBlurred = index >= 3;

                          return (
                            <tr
                              key={index}
                              style={{
                                filter: isBlurred ? "blur(4px)" : "none",
                                pointerEvents: isBlurred ? "none" : "auto",
                                transition: "filter 0.3s ease",
                              }}
                            >
                              <td>{keywordData?.keyword}</td>
                              <td>
                                #{keywordData?.rank_position}
                                <br />
                                <p className="mb-0">
                                  {keywordData?.ranking_page}
                                </p>
                              </td>
                              <td>{keywordData?.difficulty}</td>
                              <td>{keywordData?.volume}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={4} className="text-center">
                          <button
                            onClick={handleClick}
                            style={{
                              marginTop: "10px",
                              padding: "6px 16px",
                              borderRadius: "999px",
                              backgroundColor: "#0d6efd",
                              color: "#fff",
                              border: "none",
                              fontWeight: "600",
                              fontSize: "0.95rem",
                              cursor: "pointer",
                            }}
                          >
                            View Full Report
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>{" "}
              </>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Keywordgap;
